export default __webpack_public_path__ + "static/abroad-f3348427489a4b974f395239b82b4983.png";